import { VueMarkdownItPlugin } from '@f3ve/vue-markdown-it'

export default defineNuxtPlugin((nuxtApp) => {

    nuxtApp.vueApp.use(VueMarkdownItPlugin)
})
